import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { OuiButton } from 'omnium-ui/button';
import { OuiIconModule } from 'omnium-ui/icon';
import { TemplatePortal } from '@angular/cdk/portal';
import { OuiErrorPageService } from 'omnium-ui/error-page';
import { AuthService } from '@lib/auth/auth.service';

@Component({
  selector: 'lib-global-error-page',
  standalone: true,
  imports: [OuiButton, OuiIconModule],
  templateUrl: './global-error-page.component.html',
  styleUrl: './global-error-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalErrorPageComponent implements AfterViewInit {
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly errorPageService = inject(OuiErrorPageService);
  private readonly authService = inject(AuthService);

  errorType = input.required<'consultant' | 'shm'>();

  @ViewChild('globalErrorPageContent') globalErrorPageContent?: TemplateRef<unknown>;

  errorPagePortal?: TemplatePortal<any>;

  ngAfterViewInit(): void {
    this.errorPagePortal = new TemplatePortal(
      this.globalErrorPageContent!,
      this.viewContainerRef
    );
  }

  open() {
    this.errorPageService.displayErrorPage(
      'Accès restreint',
      'stop',
      this.errorPagePortal
    );
  }

  logOut(): void {
    this.authService.logout();
  }
}
